export interface IEmoji {
    unicode: string | null;
    shortcodes: string[];
    friendlyName: string;
}

export const emojiDictionary = {
    smile: {
        unicode: "🙂",
        shortcodes: [":)", ":smile:"],
        friendlyName: "Slight Smile",
    },
    frown: {
        unicode: "🙁",
        shortcodes: [":(", ":frown:"],
        friendlyName: "Slight Frown",
    },
    thumbsup: {
        unicode: "👍",
        shortcodes: [":thumbsup:", ":+1:"],
        friendlyName: "Thumbs Up",
    },
    thumbsdown: {
        unicode: "👎",
        shortcodes: [":thumbsdown:", ":-1:"],
        friendlyName: "Thumbs Down",
    },
    hammer: {
        unicode: "🔨",
        shortcodes: [":hammer:"],
        friendlyName: "Hammer",
    },
} as const;

export type EmojiTypes = keyof typeof emojiDictionary;

export const emojisByFriendlyName: Record<string, (typeof emojiDictionary)[EmojiTypes]> =
    Object.values(emojiDictionary).reduce(
        (revMap, emoji) => {
            revMap[emoji.friendlyName] = emoji;
            return revMap;
        },
        {} as Record<string, (typeof emojiDictionary)[EmojiTypes]>,
    );

export const emojisByUnicode: Record<string, (typeof emojiDictionary)[EmojiTypes]> = Object.values(
    emojiDictionary,
).reduce(
    (revMap, emoji) => {
        if (emoji.unicode) {
            revMap[emoji.unicode] = emoji;
        }
        return revMap;
    },
    {} as Record<string, (typeof emojiDictionary)[EmojiTypes]>,
);
